var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    stroke: "#36F6FF",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28.8L24.4 35.5L38.5 20.5",
    stroke: "#36F6FF",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleSuccessIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_success_icon.9ffecb25c9ad6413d23ac6bdd8e921f1.svg";
export { ForwardRef as ReactComponent };